<template>
  <v-layout row wrap class="align-center mb-12">
    <v-flex xs12>
      <v-card flat>
        <v-card-title>
          <advice color="primary">
            <span v-html="$t('validationWait.information')"></span>
          </advice>
        </v-card-title>
      </v-card>
    </v-flex>

    <v-flex class="pr-3" xs12>
      <v-layout row wrap>
        <div id="countdownContainer">
          <circular-count-down-timer
            ref="countDown"
            :initial-value="timeleft"
            :size="120"
            :hour-label="$t('validationWait.hours')"
            :minute-label="$t('validationWait.minutes')"
            :second-label="$t('validationWait.seconds')"
            :show-hour="this.showHours"
            :show-minute="this.showMinutes"
            @update="handleCounterUpdate"
            @finish="handleCounterFinish"
          ></circular-count-down-timer>
        </div>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import Advice from '@/components/commons/Advice';
import userService from '@/services/userService';

export default {
  name: 'ValidatingWait',
  components: {
    [Advice.name]: Advice
  },
  data: () => ({
    showHours: true,
    showMinutes: true
  }),
  methods: {
    handleCounterFinish: function() {
      this.$router.push({ name: 'UserHome' });
    },
    handleCounterUpdate: function(status) {
      if (status.hours === 0) {
        this.showHours = false;
        if (status.minutes === 0) {
          this.showMinutes = false;
        }
      }
    }
  },
  computed: {
    timeleft() {
      var extraTimeToWaitBeActived = 2;
      var finish = new Date(userService.registeredWithBleDate());
      finish.setSeconds(finish.getSeconds() + extraTimeToWaitBeActived);

      var seconds = Math.max(
        1,
        Math.floor((finish.getTime() - Date.now().toString()) / 1000)
      );
      if (seconds < 60 * 60) {
        this.showHours = false;
        if (seconds < 60) {
          this.showMinutes = false;
        }
      }
      return seconds;
    }
  }
};
</script>

<style>
#countdownContainer {
  width: 100%;
  height: 300px;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  overflow: scroll;
}
#countdownContainer .item {
  width: auto !important;
}
</style>
